import React, { useEffect, useState, useContext } from "react";
import UploadMedia from "../../Assets/Images/Upload_Media.png";
import LaundryPayment from "../../Pages/LaundryPayment";
import { CartContext } from "../../context/CartContext";
import Button from "../Shared/Button";
import { useRef } from "react";
import useLaundry from "../../hooks/useLaundry";
import { LoaderContext } from "../../context/LoaderContext";
import TailoringContext from "../../context/TailoringContext";
import { ImSpinner2 } from "react-icons/im";

const UploadStyles = ({
  uploadStyles,
  setUploadStyle,
  checkLength,
  setLaundryUpload,
  setLaundryDetails,
  setLaundrySummary,
  laundryNewOrder,
  ...props
}) => {
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);

  const uploadRef = useRef(null);

  const { laundryPayment, setLaundryPayment } = useContext(CartContext);
  const { errMsg } = useContext(LoaderContext);
  const { loader } = useContext(TailoringContext);

  const id = laundryNewOrder?.laundry_id?.InsertedID;

  useEffect(() => {
    // if (image?.length) {
    //   setPreview(URL.createObjectURL(image[0]));
    // }
    let fileReader, isCancel = false;
    if (image) {
      fileReader = new FileReader();
      fileReader.onload = (e) => {
        const { result } = e.target;
        if (result && !isCancel) {
          setPreview(result)
        }
      }
      fileReader.readAsDataURL(image);
    }
    return () => {
      isCancel = true;
      if (fileReader && fileReader.readyState === 1) {
        fileReader.abort();
      }
    }
  }, [image]);

  const profilePictureHandler = (e) => {
    if (e.target.files.length) {
      setPreview(e.target.files);
    }
    setImage(e.target.files[0]);
  };

  const { handleLaundryCheckout } = useLaundry();

  const formData = new FormData();
  formData.append("image", image);

  const checkoutHandler = () => {
    handleLaundryCheckout(id, formData).then((res) => {
      const checkout_url = res?.data?.responseBody?.checkoutUrl;
      window.location.href = checkout_url;
    });
  };

  return (
    <div className="col-12">
      <div className="col-12 side-menu">
        <div className="side-menu__content laundry_details">
          <div className="laundrySummary_header">
            <button
              onClick={() => setLaundryUpload(false)}
              className="backArrow"
            >
              <i className="fa-solid fa-arrow-left"></i>
              <span>Back</span>
            </button>
            <div>
              <p>Upload</p>
              {errMsg ? (
                <p className="text-danger">{errMsg}</p>
              ) : (
                <p className="summary_items">
                  For acountability purpose please upload an image of the
                  clothes to be washed
                </p>
              )}
            </div>
          </div>{" "}
          <br />
          <div className="laundry-content">
            <div className="upload_media">
              <img
                alt="img"
                className="laundryImg"
                src={preview ? preview : UploadMedia}
                style={{ maxWidth: "300px", width: "100%" }}
              />
              <div>
                <p>
                  <input
                    type="file"
                    name="image"
                    onChange={(e) => {
                      profilePictureHandler(e);
                    }}
                    ref={uploadRef}
                    style={{ opacity: 0 }}
                  />
                  <button
                    type="button"
                    className="upload_btn"
                    onClick={() => {
                      uploadRef.current?.click();
                    }}
                  >
                    Select file
                  </button>
                  from computer
                </p>
                <p>Max. 1 Image (in jpeg or png format only)</p>
              </div>
            </div>
          </div>{" "}
          <br />
          <div className="laundry-footer upload-footer">
            <div>
              {/* <ButtonContainer
                onClick={() => setLaundryPayment(!laundryPayment)}
              >
                Proceed to Pay
              </ButtonContainer> */}
              <Button
                type="button"
                text={
                  loader ? <ImSpinner2 className="spin" /> : "Proceed to Pay"
                }
                handleButtonClick={() => {
                  // setLaundryPayment(!laundryPayment);
                  checkoutHandler();
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <div
        className={
          laundryPayment
            ? "laundryPayment-menu-expanded"
            : "laundryPayment-menu"
        }
      >
        <div>
          <LaundryPayment
            {...{
              setLaundryPayment,
              setLaundryDetails,
              setLaundrySummary,
              setLaundryUpload,
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default UploadStyles;
